import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

// ─── CREATIONS ────────────────────────────────────────────────────────────────

export const HelixCreationsGetCrqsToCreateRequest = (history = false) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HelixCrqs/GetCrqsToCreate`,
	params: { history },
	hasLoading: false,
});

export const HelixCreationsGetCrqsOnQueueWithErrorRequest = (history = false) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}HelixCrqs/GetCrqsOnQueueWithError`,
	params: { history },
	hasLoading: false,
});

export const HelixCrqsToCreateActionRequest = (userId, action, idList, crqChangeIds, bot = 0) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}HelixCrqs/CrqsToCreateAction`,
	params: { userId, action, bot },
	data: { idList, crqChangeIds },
	hasLoading: true,
});

export const HelixCrqsOnQueueWithErrorActionRequest = (userId, action, idList, crqChangeIds, bot = 0) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}HelixCrqs/CrqsOnQueueWithErrorAction`,
	params: { userId, action, bot },
	data: { idList, crqChangeIds },
	hasLoading: true,
});